import constants from "../constants/constants";
import errorHandle from "../../utils/errorHandle";

const { GET_ME, GET_ME_SUCCESS, GET_ME_ERROR } = constants;

const initialState = { loading: false, user: null, error: "" };

export const userReducer = (state = initialState, action) => {
  const { type, user, error } = action;
  switch (type) {
    case GET_ME:
      return { ...state, loading: true };
    case GET_ME_SUCCESS:
      return { ...state, loading: false, user };
    case GET_ME_ERROR:
      return { ...state, loading: false, error: errorHandle(error) };

    default:
      return state;
  }
};
